import { render, staticRenderFns } from "./ProtocolPopup.vue?vue&type=template&id=767eaec4&scoped=true"
import script from "./ProtocolPopup.vue?vue&type=script&lang=js"
export * from "./ProtocolPopup.vue?vue&type=script&lang=js"
import style0 from "./ProtocolPopup.vue?vue&type=style&index=0&id=767eaec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eaec4",
  null
  
)

export default component.exports